var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _rect2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _path15, _ellipse, _ellipse2, _ellipse3, _path16, _path17, _path18, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _path19, _circle, _path20, _polygon, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 578,
    height: 578,
    viewBox: "0 0 578 578",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M889,450a287.86052,287.86052,0,0,1-68.09,186.34c-1.6,1.9-3.23,3.77-4.88995,5.63a290.58834,290.58834,0,0,1-67.49,55.99q-8.67,5.205-17.72,9.81c-.61.31-1.23.62-1.84.92-.73.37-1.47.73-2.21,1.09A286.15918,286.15918,0,0,1,679.24,728q-2.55.72-5.11,1.4a288.58782,288.58782,0,0,1-65.84,9.49c-1.16.03-2.3.05-3.4.07-.39.01-.77.02-1.15.02-1.25.01-2.49.02-3.74.02a289.27116,289.27116,0,0,1-69.54-8.43q-3.42-.84-6.81-1.77a285.47262,285.47262,0,0,1-34.97-12.03q-9-3.75-17.68-8.09c-1.31-.66-2.62-1.32-3.91-2-.55-.27-1.09-.56-1.63-.84a290.458,290.458,0,0,1-81.65-64.06c-1.6-1.79-3.17-3.61-4.72-5.44a289.02532,289.02532,0,0,1,49.59-419.1c1.64-1.21,3.29-2.41,4.96-3.58q.49494-.345.99-.69a286.75277,286.75277,0,0,1,97.1-43.85c1.98-.49,3.96-.95,5.96-1.38a291.79785,291.79785,0,0,1,114.68-2.01c1.99.37,3.98.75,5.96,1.16a287.28078,287.28078,0,0,1,97.1,39.43c.66.42,1.32.84,1.98,1.28,1.33.86,2.66,1.74,3.97,2.63A288.68578,288.68578,0,0,1,889,450Z",
    transform: "translate(-311 -161)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527,599.51l-92.37,8.2-.99.09V213.66q.49494-.345.99-.69a288.32258,288.32258,0,0,1,62.01-32.94l4.72,65.1.43,5.96,4.67,64.56L507.9,335.51l18.93,261.7Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M755.43,206.32c.66.42,1.32.84,1.98,1.28V607.8l-1.98-.18-91.37-8.11.17-2.3L683.16,335.51l1.44-19.86,4.67-64.56.43-5.96,4.95-68.27A287.68677,287.68677,0,0,1,755.43,206.32Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M755.43,206.32V613.26c0,7.81-5.38,14.16-12,14.16H446.63c-5.48,0-10.13-4.36-11.54-10.31a16.10772,16.10772,0,0,1-.46-3.85V212.97q-.495.34506-.99.69c-1.67,1.17-3.32,2.37-4.96,3.58V613.26a22.91864,22.91864,0,0,0,6.18,16,17.05993,17.05993,0,0,0,7.78,4.66,15.11793,15.11793,0,0,0,3.99.53h296.8a15.24855,15.24855,0,0,0,4-.53c7.98-2.15,13.95-10.59,13.95-20.66V210.23c-1.31-.89-2.64-1.77-3.97-2.63C756.75,207.16,756.09,206.74,755.43,206.32Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120.65518,
    y: 84.13399,
    width: 326.75223,
    height: 5.95901,
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M531.73,169.12c1.98-.49,3.96-.95,5.96-1.38V329.55h-5.96Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M652.37,165.73c1.99.37,3.98.75,5.96,1.16V329.55h-5.96Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M795.65,597.21H404.34a26.82,26.82,0,0,0,0,53.64H795.65a26.76039,26.76039,0,0,0,20.12-9.11,27.096,27.096,0,0,0,3.02-4.18,25.54045,25.54045,0,0,0,1.75-3.56,26.80329,26.80329,0,0,0-24.89-36.79Z",
    transform: "translate(-311 -161)",
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122.64151,
    y: 154.6489,
    width: 324.76589,
    height: 19.86336,
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.04494,148.6899h5.959a10.92484,10.92484,0,0,1,10.92484,10.92484v0a0,0,0,0,1,0,0h-27.8087a0,0,0,0,1,0,0v0a10.92484,10.92484,0,0,1,10.92484-10.92484Z",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M820.91,636.34a289.004,289.004,0,0,1-28.12,28.95H407.21a289.004,289.004,0,0,1-28.12-28.95Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M632.28,536.07H567.36a3.17486,3.17486,0,0,0-1.03.16,3.448,3.448,0,0,0-2.43,3.3V642.09h71.85V539.53A3.46328,3.46328,0,0,0,632.28,536.07Zm-24.57,50.6a7.53127,7.53127,0,0,1-1.56,4.6,7.665,7.665,0,0,1-13.78-4.6v-11.9a7.67033,7.67033,0,0,1,15.34,0Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M563.68,638.81v9.89a1.93971,1.93971,0,0,0,1.93,1.94h68.43a1.94622,1.94622,0,0,0,1.93-1.94v-9.89Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M739.78,376.02H462.28a9.01147,9.01147,0,0,0-9,8.99V572.27a9.0071,9.0071,0,0,0,9,9h277.5a9.00714,9.00714,0,0,0,9-9V385.01A9.01151,9.01151,0,0,0,739.78,376.02Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M737.46,382.52H464.59a4.82046,4.82046,0,0,0-4.81,4.82V569.96a4.81829,4.81829,0,0,0,4.81,4.81H737.46a4.81833,4.81833,0,0,0,4.81-4.81V387.34A4.8205,4.8205,0,0,0,737.46,382.52Z",
    transform: "translate(-311 -161)",
    fill: "#f50057"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M687.24,650.48l-2.52-11.97a2.99238,2.99238,0,0,0-1.86-2.17,2.89431,2.89431,0,0,0-1.06-.2H524.49a2.89455,2.89455,0,0,0-1.06.2,2.99262,2.99262,0,0,0-1.86,2.17l-2.52,11.97a2.98724,2.98724,0,0,0,2.92,3.6H684.31a2.94839,2.94839,0,0,0,2.32-1.11A2.98494,2.98494,0,0,0,687.24,650.48Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 224.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 234.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 244.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 254.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 264.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 274.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 284.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 294.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 304.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 314.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 324.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 334.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 344.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 354.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 364.643,
    y: 477.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 214.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 224.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 234.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 244.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 254.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 264.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 274.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 284.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 294.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 304.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 314.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 324.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 334.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 344.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 354.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 364.52484,
    y: 482.29577,
    width: 5,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 262.52484,
    y: 488.29577,
    width: 40,
    height: 3,
    rx: 0.48819,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M723.74813,407.67669H468.42477a1.01559,1.01559,0,0,1,0-2.03069H723.74813a1.01559,1.01559,0,0,1,0,2.03069Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.80496,
    cy: 233.3788,
    rx: 5.95043,
    ry: 6.08304,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.36098,
    cy: 233.3788,
    rx: 5.95043,
    ry: 6.08304,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.917,
    cy: 233.3788,
    rx: 5.95043,
    ry: 6.08304,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M711.37,389.8h-14.6a1.1053,1.1053,0,0,0,0,2.21h14.6a1.10511,1.10511,0,0,0,0-2.21Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M711.37,393.95h-14.6a1.10527,1.10527,0,0,0,0,2.21h14.6a1.10508,1.10508,0,0,0,0-2.21Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M711.37,398.1h-14.6a1.1053,1.1053,0,0,0,0,2.21h14.6a1.10511,1.10511,0,0,0,0-2.21Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 171.31411,
    y: 270.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 231.31411,
    y: 270.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 248.31411,
    y: 270.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 187.6343,
    y: 269.79312,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 267.6343,
    y: 269.79312,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 187.31411,
    y: 283.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 247.31411,
    y: 283.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 264.31411,
    y: 283.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 203.6343,
    y: 282.79312,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 283.6343,
    y: 282.79312,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 203.31411,
    y: 296.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 263.31411,
    y: 296.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 280.31411,
    y: 296.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6343,
    y: 295.79312,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 299.6343,
    y: 295.79312,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 219.31411,
    y: 309.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 279.31411,
    y: 309.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 296.31411,
    y: 309.27328,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 235.6343,
    y: 308.79312,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 231.31411,
    y: 360.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 248.31411,
    y: 360.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 267.6343,
    y: 361.44697,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 171.31411,
    y: 360.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 187.6343,
    y: 361.44697,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 187.31411,
    y: 347.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 247.31411,
    y: 347.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 264.31411,
    y: 347.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 203.6343,
    y: 348.44697,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 203.31411,
    y: 334.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 263.31411,
    y: 334.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 280.31411,
    y: 334.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6343,
    y: 335.44697,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 219.31411,
    y: 321.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 279.31411,
    y: 321.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 296.31411,
    y: 321.9668,
    width: 11.00609,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 235.6343,
    y: 322.44697,
    width: 38.3657,
    height: 5.75992,
    rx: 2.87996,
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M726.81,709.77c-.61.31-1.23.62-1.84.92-15.8,7.9-28.43994,12.39-45.73,17.31-1.46-16.3-2.87-44.95-4.24-62.71-.36-4.61-.72-8.48-1.07-11.21a15.1823,15.1823,0,0,0-.88-4.25l.06,4.25.15,11.21.87,64.11a288.58782,288.58782,0,0,1-65.84,9.49c-1.16.03-2.3.05-3.4.07-.39.01-.77.02-1.15.02-1.25.01-2.49.02-3.74.02a289.27116,289.27116,0,0,1-69.54-8.43c.49-16.13.98-44.46,1.45-65.28.1-4.07.19-7.86.29-11.21.19-7.16.39-12.32.58-14.05a4.36108,4.36108,0,0,0-.39.97,97.15388,97.15388,0,0,0-1.89,13.08c-.35,3.35-.7,7.14-1.05,11.21-1.86,21.63-3.8,51.04-5.8,63.51a285.47262,285.47262,0,0,1-34.97-12.03q-9-3.75-17.68-8.09c1.1-7.2,2.25-15.27,3.43-23.64.92-6.49,1.87-13.16,2.84-19.75,1.5-10.18,3.04-20.16,4.6-28.95,2.28-12.84,4.62-23.16,6.94-27.9,2.2-4.5,4.4-8.94,6.53-13.19.74-1.49,1.48-2.96,2.2-4.39.17-.34.34-.67.51-1,1.53-3.01,3.01-5.89,4.42-8.59,1.21-2.31,2.36005-4.49,3.45-6.5,2.64-4.88,4.88-8.77,6.54-11.23a55.25656,55.25656,0,0,1,29.28-22.21l.3-.08.21.09,20.45-6.28,2.99-.92,2.01-.62,7.08-5.39,3.85-2.93,3.61-2.75,7.06-5.37,43.71,2.69,8.51,20.49,19.06,6.97.33-.15.29-.12.3.08a55.306,55.306,0,0,1,29.28,22.21c.93994,1.41,2.08,3.27,3.37,5.52,1.1,1.91,2.3,4.09,3.6,6.5,1.85,3.43005,3.87,7.30005,6.01,11.49.47.92.95,1.86,1.43,2.81q1.335,2.63993,2.71,5.38995c2.13,4.25,4.33,8.69,6.53,13.2,1.91,3.91,3.84,11.95,5.74,22.18,1.57,8.5,3.13,18.52,4.64,28.95,1.98,13.52-.13,29.71,1.66,42.15C726.58,708.23,726.7,709,726.81,709.77Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 289.61504,
    cy: 288.88825,
    r: 50.83645,
    fill: "#a0616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M684.45,382.52a26.60846,26.60846,0,0,0-3.97-6.5c-7.72-9.43-21.76-13.58-36.17-2.42a15.27875,15.27875,0,0,0-8.35.48,12.91024,12.91024,0,0,0-3.52,1.94,15.97041,15.97041,0,0,0-4.94,6.5,15.52156,15.52156,0,0,0-1.1,4.23,50.56537,50.56537,0,0,0-11.23-4.23,60.33992,60.33992,0,0,0-29.13,0,36.54359,36.54359,0,0,0-8.78,3.48c-4.68,2.7-7.37,6.11-7.85,9.9-6.75.38-13.77,3.93-19,9.75-.59.65-1.16,1.33-1.69,2.03A32.70853,32.70853,0,0,0,542,427.73V429h1.27a26.87038,26.87038,0,0,1,10.15,1.98,27.58525,27.58525,0,0,1,5.89,3.25,28.764,28.764,0,0,1,3.37,2.8,33.48321,33.48321,0,0,1,6.12,8.05,37.4595,37.4595,0,0,1,4.08,24.71,36.19955,36.19955,0,0,1-1.52,5.76,37.58443,37.58443,0,0,1-3.71,7.63c-.06.09-.11.18-.17.27-.67,1.07-1.31,2.16-1.91,3.26-.45.82-.87,1.66-1.26,2.5a51.95669,51.95669,0,0,0-2.88,7.24,53.58646,53.58646,0,0,0-2.44,13.54c-.07,1.22-.09,2.44-.05,3.66a51.97943,51.97943,0,0,0,1.03,9.36005c.09.42.18005.83.27,1.25l.73,3.19,1.73,7.61,1.2,5.24,1.11,4.86,1.64-2.35c.56-.8,1.97-3.26,3.86-6.74,1.25-2.27,2.7-4.98,4.27-7.94,2.18994-4.15,4.59-8.78,6.93994-13.4.95-1.87,1.89-3.73,2.80005-5.55,1.72-3.45,3.34-6.78,4.73-9.74,1.28-2.73,2.37-5.15,3.18-7.09.25,1.27.46,2.56.62,3.86.18,1.32.31,2.66.38,4,.02.2.03.41.04.61005l.04.82.01.24,1.06.14a93.02194,93.02194,0,0,0,18.4.14h.01a74.86185,74.86185,0,0,0,23.56-5.71,49.25718,49.25718,0,0,0,11.8-7.24,41.3,41.3,0,0,0,4.66-4.52c.36-.41.71-.82,1.05-1.24a41.12455,41.12455,0,0,0,5.05-7.9,41.80164,41.80164,0,0,0,2.34-5.76c3.84-11.63,3.62-26.14-.66-43.38a9.923,9.923,0,0,0,3.27-1.26c3.14-1.88995,5.32-5.63995,6-10.22l1.08.29a30.104,30.104,0,0,0,10.01-7.54,24.11545,24.11545,0,0,0,1.54-2.03C687.58,398.45,687.62,389.81,684.45,382.52Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "206.32 475.296 214.817 442.504 222.32 470.8 206.32 475.296",
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M743.43,614.93c-3.04,41.88.11,60.32-16.67,94.85A286.15918,286.15918,0,0,1,679.24,728q-2.55.72-5.11,1.4a288.58782,288.58782,0,0,1-65.84,9.49c-1.16.03-2.3.05-3.4.07-.39.01-.77.02-1.15.02-1.25.01-2.49.02-3.74.02a289.27116,289.27116,0,0,1-69.54-8.43q-3.42-.84-6.81-1.77a285.47262,285.47262,0,0,1-34.97-12.03q-9-3.75-17.68-8.09c-1.31-.66-2.62-1.32-3.91-2-6.63-11.66-10.4-25.84-10.48-42.88C461.2,634.44,733.29,589.61,743.43,614.93Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M743.42212,622.10217c.15527-2.59271.32886-5.27093.53131-8.05987-10.14-25.32-282.23,19.51-286.82,48.87.01264,2.69184.12775,5.30414.32129,7.85456C468.57031,641.78857,727.05945,599.18054,743.42212,622.10217Z",
    transform: "translate(-311 -161)",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M474.09552,503.15162a6.36455,6.36455,0,0,0-6.75274-6.81562,5.8541,5.8541,0,0,0-1.00507.12575l-39.7621,8.98257a6.54762,6.54762,0,0,0-4.20873,3.23509,8.18371,8.18371,0,0,0-1.72738.25112,9.66133,9.66133,0,0,0,4.2714,18.84464,9.79394,9.79394,0,0,0,3.89453-1.88439l13.474,37.9406a6.3285,6.3285,0,0,0,6.941,3.04646l25.84869-5.84179A6.41623,6.41623,0,0,0,480,555.31982Zm-49.78137,21.92253a6.91049,6.91049,0,0,1-3.0779-13.47385c.12556-.03144.25132,0,.37688-.03144a6.50647,6.50647,0,0,0,.84807,3.26634l4.93085,8.60569A6.50519,6.50519,0,0,1,424.31415,525.07415Z",
    transform: "translate(-311 -161)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M467.34278,496.336c.37688,5.02535-8.22881,10.80427-19.75539,13.09716-10.58459,2.16714-20.06959.65944-22.73936-3.29777a6.02524,6.02524,0,0,1,1.72758-.69107l39.7621-8.98257A5.8541,5.8541,0,0,1,467.34278,496.336Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M439.84333,623.90524,462.177,612.73843l-18.6114-50.25079-4.90493-25.342a19.16137,19.16137,0,0,0-31.28219-10.90731h0a19.16136,19.16136,0,0,0-2.49251,26.51833l18.20719,22.75891Z",
    transform: "translate(-311 -161)",
    fill: "#a0616a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M462.177,603.43273l-29.77821,14.889,22.59854,70.80908A30.9768,30.9768,0,0,0,477.333,709.84721h0a30.97681,30.97681,0,0,0,33.73743-14.197l59.92487-102.71393a31.62026,31.62026,0,0,0-10.19564-42.982h0a31.62037,31.62037,0,0,0-45.29613,12.76511l-36.576,77.93632Z",
    transform: "translate(-311 -161)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M452.9668,539.44141a.49632.49632,0,0,1-.1626-.02735l-6.50147-2.23828a.49923.49923,0,0,1-.20556-.81055l4.83545-5.26464a.49972.49972,0,1,1,.73633.67578l-4.31885,4.70215,5.77929,1.99023a.49991.49991,0,0,1-.16259.97266Z",
    transform: "translate(-311 -161)",
    fill: "#f50057"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M461.87842,537.61719a.5.5,0,0,1-.34766-.85938l4.39453-4.249-5.90332-2.43262a.49963.49963,0,1,1,.38086-.92383l6.60938,2.72364a.49951.49951,0,0,1,.15722.82129l-4.94336,4.77929A.49966.49966,0,0,1,461.87842,537.61719Z",
    transform: "translate(-311 -161)",
    fill: "#f50057"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M454.33154,542.5a.48228.48228,0,0,1-.147-.02246.49976.49976,0,0,1-.33105-.625l4.61474-15a.50026.50026,0,0,1,.95606.29492l-4.61475,15A.50035.50035,0,0,1,454.33154,542.5Z",
    transform: "translate(-311 -161)",
    fill: "#f50057"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech);
export default __webpack_public_path__ + "static/media/tech.265c352e1bc8a2dd98782d33b964d432.svg";
export { ForwardRef as ReactComponent };